<div class="overlays-dots" *ngIf="overlaysLoader$ | async" [@timeline-status]>
	<div class="loading-container">
		<div></div>
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>
